import {
  absoluteUrl,
  BUSINESS,
  DEFAULT_OG_IMAGE,
  SERVICE_COUNTIES,
  SERVICE_CITIES,
  SITE_NAME,
  SITE_URL,
} from "./siteConfig";

const kentuckyPlace = (type, name) => ({
  "@type": type,
  name,
  addressRegion: BUSINESS.addressRegion,
  addressCountry: BUSINESS.addressCountry,
});

export const buildJsonLdGraph = (items) => ({
  "@context": "https://schema.org",
  "@graph": items.filter(Boolean),
});

export const localBusinessSchema = () => ({
  "@type": "SportsActivityLocation",
  "@id": `${SITE_URL}/#organization`,
  name: BUSINESS.name,
  url: SITE_URL,
  telephone: BUSINESS.telephone,
  email: BUSINESS.email,
  image: absoluteUrl(DEFAULT_OG_IMAGE),
  address: {
    "@type": "PostalAddress",
    streetAddress: BUSINESS.streetAddress,
    addressLocality: BUSINESS.addressLocality,
    addressRegion: BUSINESS.addressRegion,
    postalCode: BUSINESS.postalCode,
    addressCountry: BUSINESS.addressCountry,
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: BUSINESS.latitude,
    longitude: BUSINESS.longitude,
  },
  sameAs: [BUSINESS.facebook, BUSINESS.instagram],
  areaServed: [
    ...SERVICE_CITIES.map((city) => kentuckyPlace("City", city)),
    ...SERVICE_COUNTIES.map((county) =>
      kentuckyPlace("AdministrativeArea", county)
    ),
  ],
});

export const webSiteSchema = () => ({
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  publisher: { "@id": `${SITE_URL}/#organization` },
});

export const faqPageSchema = (items) => {
  if (!items?.length) return null;
  return {
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.a,
      },
    })),
  };
};

export const sportsEventSchema = ({
  name,
  description,
  path,
  registrationUrl,
  locationName,
  streetAddress,
  addressLocality,
  addressRegion,
  postalCode,
  startDate,
  endDate,
  image,
}) => ({
  "@type": "SportsEvent",
  name,
  description,
  url: absoluteUrl(path),
  eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  eventStatus: "https://schema.org/EventScheduled",
  sport: "Artistic Gymnastics",
  ...(startDate ? { startDate } : {}),
  ...(endDate ? { endDate: endDate || startDate } : {}),
  ...(image ? { image: [image] } : {}),
  location: {
    "@type": "Place",
    name: locationName || BUSINESS.name,
    address: {
      "@type": "PostalAddress",
      streetAddress: streetAddress || BUSINESS.streetAddress,
      addressLocality: addressLocality || BUSINESS.addressLocality,
      addressRegion: addressRegion || BUSINESS.addressRegion,
      postalCode: postalCode || BUSINESS.postalCode,
      addressCountry: BUSINESS.addressCountry,
    },
  },
  organizer: {
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
  },
  ...(registrationUrl
    ? { offers: { "@type": "Offer", url: registrationUrl, availability: "https://schema.org/InStock" } }
    : {}),
});
